<template>
  <div class="ui-pannel">
    <p class="title">{{$t("title")}}</p>
    <div class="content">
      <p class="topic">{{$t('login')}}</p>
      <div class="row">
        <div class="lab">{{$t('old')}}</div>
        <div class="psw-item">
          <input type="text" v-if="see[0]" @focus="error.splice(0, 1, 0)" :placeholder="$t('form.enter')+$t('old')" v-model="psw1.oldPwd">
          <input type="password" @focus="error.splice(0, 1, 0)" v-else :placeholder="$t('form.enter')+$t('old')" v-model="psw1.oldPwd">
          <a class="view" @click="setSee(0)" :class="{see: see[0]}"></a>
          <p class="ui-error" v-if="error[0] === 1">旧密码不能为空</p>
          <p class="ui-error" v-if="error[0] === 2">登录密码输入不正确</p>
        </div>
      </div>
      <div class="row">
        <div class="lab">{{$t('new')}}</div>
        <div class="psw-item">
          <input type="text" v-if="see[1]" @focus="error.splice(1, 1, 0)" :placeholder="$t('form.enter')+$t('new')" v-model="psw1.newPwd">
          <input type="password" v-else @focus="error.splice(1, 1, 0)" :placeholder="$t('form.enter')+$t('new')" v-model="psw1.newPwd">
          <a class="view" @click="setSee(1)" :class="{see: see[1]}"></a>
          <p class="ui-error" v-if="error[1] === 1">新密码不能为空</p>
          <p class="ui-error" v-if="error[1] === 2">新密码与确认密码输入不一致</p>
        </div>
      </div>
      <div class="row">
        <div class="lab">{{$t('new2')}}</div>
        <div class="psw-item">
          <input type="text" v-if="see[2]" @focus="error.splice(1, 1, 0)" :placeholder="$t('again')" v-model="psw1.newPwd2">
          <input type="password" v-else @focus="error.splice(1, 1, 0)" :placeholder="$t('again')" v-model="psw1.newPwd2">
          <a class="view" @click="setSee(2)" :class="{see: see[2]}"></a>
        </div>
      </div>
      <a class="ui-btn" @click="changeLoginPsw">{{$t("common.save")}}</a>
      <template v-if="user.userType === 10">
        <hr class="line">
        <p class="topic">{{$t('pay')}}</p>
        <div class="row">
          <div class="lab">{{$t('old')}}</div>
          <div class="psw-item">
            <input type="text" v-if="see[3]" @focus="error.splice(2, 1, 0)" :placeholder="$t('form.enter')+$t('old')" v-model="psw2.oldPwd">
            <input type="password" @focus="error.splice(2, 1, 0)" v-else :placeholder="$t('form.enter')+$t('old')" v-model="psw2.oldPwd">
            <a class="view" @click="setSee(3)" :class="{see: see[3]}"></a>
            <p class="ui-error" v-if="error[2] === 1">旧密码输入不正确</p>
          </div>
        </div>
        <div class="row">
          <div class="lab">{{$t('new')}}</div>
          <div class="psw-item">
            <input type="text" v-if="see[4]" @focus="error.splice(3, 1, 0)" :placeholder="$t('form.enter')+$t('new')" v-model="psw2.newPwd">
            <input type="password" v-else @focus="error.splice(3, 1, 0)" :placeholder="$t('form.enter')+$t('new')" v-model="psw2.newPwd">
            <a class="view" @click="setSee(4)" :class="{see: see[4]}"></a>
            <p class="ui-error" v-if="error[3] === 1">新密码不能为空</p>
            <p class="ui-error" v-if="error[3] === 2">新密码与确认密码输入不一致</p>
          </div>
        </div>
        <div class="row">
          <div class="lab">{{$t('new2')}}</div>
          <div class="psw-item">
            <input type="text" v-if="see[5]" @focus="error.splice(3, 1, 0)" :placeholder="$t('again')" v-model="psw2.newPwd2">
            <input type="password" v-else @focus="error.splice(3, 1, 0)" :placeholder="$t('again')" v-model="psw2.newPwd2">
            <a class="view" @click="setSee(5)" :class="{see: see[5]}"></a>
          </div>
        </div>
        <a class="ui-btn" @click="setOrModifyPayPwd">{{$t("common.save")}}</a>
      </template>
    </div>
  </div>
</template>
<script>
import {modifyPwd, setOrModifyPayPwd} from '@/service/api.js'
import {logout} from '@/service/loginAndRegistApi.js'
export default {
  data(){
    return {
      psw1: {
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      psw2: {
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      see: [false, false, false, false, false, false],
      error: [0, 0, 0, 0]
    }
  },
  computed: {
    user(){
      return JSON.parse(this.$store.getters.GETUSER) 
    }
  },
  methods: {
    setSee(index){
      this.see[index] = !this.see[index]
      this.$forceUpdate()
    },
    async changeLoginPsw(){
      if(this.psw1.oldPwd){
        if(this.psw1.newPwd && this.psw1.newPwd === this.psw1.newPwd2){
          let res = await modifyPwd(this.psw1)
          if(res.data.status === 1){
            this.$message({message: '密码修改成功，请重新登录', type: 'success'})
            res = await logout()
            sessionStorage.setItem('1to1token', '')
            this.$router.push({path: '/login'})
          }else if(res.data.status === 400138){
            this.error[0] = 2
          }
        }else if(!this.psw1.newPwd){
          this.error[1] = 1
        }else{
          this.error[1] = 2
        }
      }else{
        this.error[0] = 1
      }
      this.$forceUpdate()
    },
    async setOrModifyPayPwd(){
      if(this.psw2.newPwd && this.psw2.newPwd === this.psw2.newPwd2){
        let res = await setOrModifyPayPwd(this.psw2)
        if(res.data.status === 1){
          this.$message({message: this.$t('paySuccessTip'), type: 'success'})
        }else if(res.data.status === 400138){
          this.error[2] = 1
        }
      }else if(!this.psw2.newPwd){
        this.error[3] = 1
      }else{
        this.error[3] = 2
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
.content{padding: 0 50px 100px;}
.topic{padding: 40px 0 20px; line-height: 27px; font-size: 21px; font-weight: bold;}
.row{margin-top: 20px; display: flex;}
.lab{line-height: 50px; min-width: 180px; padding-right: 20px; font-size: 18px; color: #333;}
.psw-item{
  position: relative; width: 400px; height: 50px;
  input{background: #ededed; border-radius: 50px; padding: 10px 70px 10px 35px; line-height: 28px; border: 1px solid #ededed; width: 100%;}
  .view{position: absolute; right: 25px; top: 10px; color: #999; width: 30px; height: 30px; background: url(../assets/eye2.png) no-repeat center center;}
  .see{background-image: url(../assets/eye.png);}
}
.line{margin: 50px 0 10px;}
.ui-btn{margin-top: 80px;}
</style>
<i18n>
{
  "cn": {
    "login": "登录密码",
    "pay": "支付密码",
    "old": "旧密码",
    "new": "新密码",
    "new2": "确认密码",
    "title": "设置密码",
    "again": "请再次输入您的新密码",
    "paySuccessTip":"支付密码修改成功"
  },
  "TW": {
    "login": "登入密碼",
    "pay": "支付密碼",
    "old": "舊密碼",
    "new": "新密碼",
    "new2": "確認密碼",
    "title": "設置密碼",
    "again": "請再次輸入您的新密碼",
    "paySuccessTip":"支付密碼修改成功"
  },
  "en": {
    "login": "Login password",
    "pay": "Payment password",
    "old": "existing password",
    "new": "new password",
    "new2": "Confirm password",
    "title": "Change password",
    "again": "Please enter your new password again",
    "paySuccessTip":"Payment password successfully changed"
  }
}
</i18n>